export default __webpack_public_path__ + "media/src/usersite/images/footer/background-44f08447fdfe5e3a0887cee2b296f7e5.png";